/* eslint-disable prettier/prettier */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-bind */
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb, Empty } from 'antd';
import React, { useEffect, useState, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import { format, parseISO } from 'date-fns';

import currencyFormatter from 'currency-formatter';

import { Container } from './styles';
import { PageTitle } from '../../components/PageTitle';

import { api } from '../../services/api';
import { Filters } from './components/Filters';
import { Loading } from '../../components/Loading';
import { AdminOrdersTable } from './components/AdminOrdersTable';
import { useAuth } from '../../hooks/AuthContext';
import { OrdersTable } from './components/OrdersTable';
import { ModalOrderCancel } from './components/ModalOrderCancel';
import { ProofreaderOrdersTable } from './components/ProofreaderOrdersTable';
import { ModalStartCorrection } from './components/ModalStartCorrection';
import { ModalStartPreAnalysis } from './components/ModalStartPreAnalysis';

export function Orders() {
  const { user } = useAuth();

  const [orders, setOrders] = useState([]);
  const [ordersTotalValue, setOrdersTotalValue] = useState(0);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [ordersTotalSearch, setOrdersTotalSearch] = useState(0);
  const [allOrdersTotalValue, setAllOrdersTotalValue] = useState(0);
  const [loading, setLoading] = useState(true);

  // Filters
  const [filterCorrectionStatus, setFilterCorrectionStatus] = useState('');
  const [filterPaymentStatus, setFilterPaymentStatus] = useState('');
  const [searchWord, setSearchWord] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  // Aprova pagamento
  const [showModalApprovePayment, setShowModalApprovePayment] = useState(false);

  const [paginationPage, setPaginationPage] = useState(null);
  const [searchPaginationPage, setSearchPaginationPage] = useState(null);
  const [searchTotalOrders, setSearchTotalOrders] = useState(0);

  // Modal Order Cancel
  const [isOpenModalOrderCancel, setIsOpenModalOrderCancel] = useState(false);
  const [orderToCancel, setOrderToCancel] = useState();

  // Modal Start Correction
  const [isOpenModalStartCorrection, setIsOpenModalStartCorrection] =
    useState(false);
  const [orderToStartCorrection, setOrderToStartCorrection] = useState();

  // Modal Start Préanalise
  const [isOpenModalStartPreAnalysis, setIsOpenModalStartPreAnalysis] =
    useState(false);
  const [orderToStartPreAnalysis, setOrderToStartPreAnalysis] = useState();

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [filtersLoaded, setFiltersLoaded] = useState(false);

  async function loadOrders() {
    try {
      setLoading(true);
      const response = await api.get(`/orders/?page=${paginationPage || 1}`);

      const ordersFormmated = response.data.orders.map((order, index) => ({
        ...order,
        key: index,
        product_id: order.product.code,
        product_name: order.product.name,
        order_id: order.order_number,
        payment_status: [order.payment_status],
        payment_status_two: [order.payment_status_two],
        correction_status: [order.correction_status],
        client: order.client,
        createdFormatted: format(
          parseISO(order.created_at),
          'dd/MM/yyyy - H:mm:ss',
        ),
        total_value_formatted: currencyFormatter.format(
          order.total_value / 100,
          {
            code: 'BRL',
          },
        ),
        product_name_formated:
          order.product.name.length > 25
            ? `${order.product.name.substring(0, 25)}...`
            : order.product.name,
        have_virtual_dispatcher: order.order_items && order.order_items.length && order.order_items[0] && order.order_items[0].item && order.order_items[0].item.payment_status && order.order_items[0].item.payment_status === 'PAID',
      }));

      const totalValue = response.data.orders.reduce(
        (currentValue, nextValue) => currentValue + nextValue.total_value / 100,
        0,
      );
      setOrdersTotal(response.data.total_orders);
      setAllOrdersTotalValue(response.data.total_orders_value / 100);

      setOrders(ordersFormmated);
      setOrdersTotalValue(totalValue);
      setLoading(false);
    } catch (error) {
      console.log(error);
      toast.error('Erro ao carregar pedidos');
      setLoading(false);
    }
  }

  const [checkedFilters, setCheckedFilters] = useState([]);

  const downloadCSV = (csvUrl) => {
    const link = document.createElement('a');
    link.href = csvUrl;
    link.setAttribute('download', 'export.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const searchOrders = async (is_export) => {
    try {
      setLoading(true);
      setIsSearching(true);

      const have_virtual_dispatcher = checkedFilters.some(
        (filterItem) => filterItem === 'have_virtual_dispatcher',
      );

      const is_pre_analysis = checkedFilters.some(
        (filterItem) => filterItem === 'is_pre_analysis',
      );

      const response = await api.get(
        `/orders/admin/search/?search_word=${searchWord}&correction_status=${filterCorrectionStatus}&payment_status=${filterPaymentStatus}&start_date=${startDate && format(startDate, 'yyyy-MM-dd')}&end_date=${endDate && format(endDate, 'yyyy-MM-dd')}&have_virtual_dispatcher=${have_virtual_dispatcher}&is_pre_analysis=${is_pre_analysis}&page=${searchPaginationPage || 1}&is_export=${is_export}`,
      );

      let ordersData = response.data.orders;

      if (have_virtual_dispatcher) {
        ordersData = response.data.orders.filter(orderItem => orderItem.order_items && orderItem.order_items.length && orderItem.order_items[0] && orderItem.order_items[0].item && orderItem.order_items[0].item.payment_status === 'PAID');
      }

      const ordersFormmated = ordersData.map((order, index) => ({
        ...order,
        key: index,
        product_id: order.product.code,
        product_name: order.product.name,
        order_id: order.order_number,
        payment_status: [order.payment_status],
        correction_status: [order.correction_status],
        payment_status_two: [order.payment_status_two],
        client: order.client,
        createdFormatted: format(
          parseISO(order.created_at),
          'dd/MM/yyyy - H:mm:ss',
        ),
        total_value_formatted: currencyFormatter.format(
          order.total_value / 100,
          {
            code: 'BRL',
          },
        ),
        product_name_formated:
          order.product.name.length > 25
            ? `${order.product.name.substring(0, 25)}...`
            : order.product.name,
        have_virtual_dispatcher: order.order_items && order.order_items.length && order.order_items[0] && order.order_items[0].item && order.order_items[0].item.payment_status && order.order_items[0].item.payment_status === 'PAID',
      }));

      const totalValue = response.data.orders.reduce(
        (currentValue, nextValue) => currentValue + nextValue.total_value / 100,
        0,
      );

      if (response.data.orders_csv_url) {
        downloadCSV(response.data.orders_csv_url);
      }

      setSearchTotalOrders(response.data.total_orders);
      setOrders(ordersFormmated);
      setOrdersTotalSearch(response.data.orders.length);
      setAllOrdersTotalValue(totalValue);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setIsSearching(false);
      console.log(error);
      toast.error('Erro ao buscar usuários');
    }
  };

  useEffect(() => {
    if (!filtersLoaded) return;

    if (isSearching && (searchPaginationPage !== null && searchPaginationPage !== undefined)) {
      searchOrders();
    } else {
      loadOrders();
    }
  }, [filtersLoaded, isSearching, paginationPage, searchPaginationPage]);

  function clearSearch() {
    setFilterCorrectionStatus('');
    setFilterPaymentStatus('');
    setSearchWord('');
    setIsSearching(false);
    setStartDate();
    setEndDate();
    loadOrders();
    setCheckedFilters([]);
    setPaginationPage(1);
    setSearchPaginationPage(1);
  }

  const isRenderAdminOrderTable = useMemo(
    () => !loading && !!orders.length && user.permission_level === 'master',
    [user, orders, loading],
  );

  const isRenderCoordinatorOrderTable = useMemo(
    () => user.permission_level === 'coordinator',
    [(user, orders, loading)],
  );

  const isRenderProofreaderOrderTable = useMemo(
    () => user.permission_level === 'proofreader',
    [(user, orders, loading)],
  );

  useEffect(() => {
    setSearchPaginationPage(null);
  }, [filterCorrectionStatus, filterPaymentStatus, searchWord]);

  useEffect(() => {
    const savedFilters = localStorage.getItem('@RO:ordersFilters');
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);
      console.log('Filtros', filters);
      setFilterCorrectionStatus(filters.filterCorrectionStatus || '');
      setFilterPaymentStatus(filters.filterPaymentStatus || '');
      setStartDate(filters.startDate ? new Date(filters.startDate) : undefined);
      setEndDate(filters.endDate ? new Date(filters.endDate) : undefined);
      setSearchWord(filters.searchWord || '');
      setCheckedFilters(filters.checkedFilters || []);
      setPaginationPage(filters.paginationPage || 1);
      setSearchPaginationPage(filters.searchPaginationPage || 1);
      setIsSearching(filters.isSearching || false);
    }

    setFiltersLoaded(true);
  }, []);

  useEffect(() => {
    if (!filtersLoaded) return;

    const filters = {
      filterCorrectionStatus,
      filterPaymentStatus,
      startDate,
      endDate,
      searchWord,
      checkedFilters,
      paginationPage,
      isSearching,
      searchPaginationPage,
    };

    localStorage.setItem('@RO:ordersFilters', JSON.stringify(filters));
  }, [
    filterCorrectionStatus,
    filterPaymentStatus,
    startDate,
    endDate,
    searchWord,
    checkedFilters,
    filtersLoaded,
    paginationPage,
    isSearching,
    searchPaginationPage,
  ]);

  console.log('Log', {
    paginationPage,
  });

  return (
    <Container>
      <Breadcrumb style={{ marginBottom: 40 }}>
        <Breadcrumb.Item key="/">
          <NavLink to="/">
            <HomeOutlined />
          </NavLink>
        </Breadcrumb.Item>
      </Breadcrumb>

      <PageTitle title="Pedidos" description="Todos os pedidos da loja" />

      <Filters
        filterCorrectionStatus={filterCorrectionStatus}
        setFilterCorrectionStatus={setFilterCorrectionStatus}
        filterPaymentStatus={filterPaymentStatus}
        setFilterPaymentStatus={setFilterPaymentStatus}
        setSearchWord={setSearchWord}
        clearSearch={clearSearch}
        search={searchOrders}
        searchWord={searchWord}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        checkedFilters={checkedFilters}
        setCheckedFilters={setCheckedFilters}
      />

      {!loading && !!orders.length && (
        <>
          {isRenderAdminOrderTable && (
            <AdminOrdersTable
              orders={orders}
              loading={loading}
              showModalApprovePayment={showModalApprovePayment}
              setShowModalApprovePayment={setShowModalApprovePayment}
              paginationPage={paginationPage}
              setPaginationPage={setPaginationPage}
              searchPaginationPage={searchPaginationPage}
              setSearchPaginationPage={setSearchPaginationPage}
              ordersTotal={isSearching ? ordersTotalSearch : ordersTotal}
              isSearching={isSearching}
              ordersTotalValue={ordersTotalValue}
              setIsOpenModalOrderCancel={setIsOpenModalOrderCancel}
              setOrderToCancel={setOrderToCancel}
              allOrdersTotalValue={allOrdersTotalValue}
              searchTotalOrders={searchTotalOrders}
            />
          )}

          {isRenderCoordinatorOrderTable && (
            <OrdersTable
              orders={orders}
              loading={loading}
              paginationPage={paginationPage}
              setPaginationPage={setPaginationPage}
              ordersTotal={isSearching ? orders.length : ordersTotal}
              isSearching={isSearching}
              searchPaginationPage={searchPaginationPage}
              setSearchPaginationPage={setSearchPaginationPage}
            />
          )}

          {isRenderProofreaderOrderTable && (
            <ProofreaderOrdersTable
              orders={orders}
              loading={loading}
              paginationPage={paginationPage}
              setPaginationPage={setPaginationPage}
              ordersTotal={isSearching ? orders.length : ordersTotal}
              isSearching={isSearching}
              setIsOpenModalStartCorrection={setIsOpenModalStartCorrection}
              setOrderToStartCorrection={setOrderToStartCorrection}
              setOrderToStartPreAnalysis={setOrderToStartPreAnalysis}
              setIsOpenModalStartPreAnalysis={setIsOpenModalStartPreAnalysis}
              searchPaginationPage={searchPaginationPage}
              setSearchPaginationPage={setSearchPaginationPage}
            />
          )}
        </>
      )}

      {!loading && !orders.length && (
        <Empty
          description="Nenhum produto foi encontrado"
          style={{ marginTop: '150px' }}
        />
      )}

      {loading && <Loading />}

      <ModalOrderCancel
        isOpenModalOrderCancel={isOpenModalOrderCancel}
        setIsOpenModalOrderCancel={setIsOpenModalOrderCancel}
        orderToCancel={orderToCancel}
        loadOrders={loadOrders}
      />

      <ModalStartCorrection
        isOpenModalStartCorrection={isOpenModalStartCorrection}
        setIsOpenModalStartCorrection={setIsOpenModalStartCorrection}
        orderToStartCorrection={orderToStartCorrection}
      />

      <ModalStartPreAnalysis
        isOpenModalStartPreAnalysis={isOpenModalStartPreAnalysis}
        setIsOpenModalStartPreAnalysis={setIsOpenModalStartPreAnalysis}
        orderToStartPreAnalysis={orderToStartPreAnalysis}
      />
    </Container>
  );
}
